/**
 * Cliente API para configuracion_notificaciones (Sprint 11 v2
 * S11-V2-11).
 *
 * Endpoints backend (registrados en `app/api/configuracion_notificaciones.py`):
 * - GET /configuracion-notificaciones/ → lista histórica desc.
 * - GET /configuracion-notificaciones/vigente?fecha=YYYY-MM-DD → fila vigente.
 * - POST /configuracion-notificaciones/ → nueva fila append-only.
 */
import { apiFetch } from './client';
import type {
  ConfiguracionNotificaciones,
  ConfiguracionNotificacionesCreate,
} from './types';

export function listConfiguracionesNotificaciones(): Promise<
  ConfiguracionNotificaciones[]
> {
  return apiFetch<ConfiguracionNotificaciones[]>(
    '/configuracion-notificaciones/',
  );
}

export function getVigenteNotificaciones(
  fecha?: string,
): Promise<ConfiguracionNotificaciones> {
  const qs = fecha ? `?fecha=${fecha}` : '';
  return apiFetch<ConfiguracionNotificaciones>(
    `/configuracion-notificaciones/vigente${qs}`,
  );
}

export function createConfiguracionNotificaciones(
  data: ConfiguracionNotificacionesCreate,
): Promise<ConfiguracionNotificaciones> {
  return apiFetch<ConfiguracionNotificaciones>(
    '/configuracion-notificaciones/',
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  );
}
